import { useState } from "react";
import { useParams } from "react-router-dom";
import { Button, CircularProgress, Paper, Stack, Typography } from "@mui/material";
import Drawer from "./Drawer";
import { Faq, NewFaq } from "@/types/faq";
import { EmptyState, SortableList } from "@/components";
import { useDeleteFaqMutation, useFetchFaqsQuery, useUpdateFaqMutation } from "@/features/organizations/api/faqApi";
import { skipToken } from "@reduxjs/toolkit/dist/query";
import PageHeader from "@/components/PageHeader";
import { useAccessControl } from "@/features/access-control";

export const EMPTY_FAQ: NewFaq = {
  question: "",
  answer: "",
};

const OrganizationFaqs = () => {
  const [selectedFaq, setSelectedFaq] = useState<Faq | NewFaq>();
  const { organizationId } = useParams<{ organizationId: string }>();
  const { hasAccess } = useAccessControl();
  const { data, isLoading } = useFetchFaqsQuery(organizationId || skipToken);
  const [deleteFaq] = useDeleteFaqMutation();
  const [updateFaq] = useUpdateFaqMutation();

  const handleDelete = (faqId: string) => {
    if (!organizationId || !faqId) return;
    deleteFaq({ organizationId, faqId });
  };

  const handleEdit = (faq: Faq) => {
    delete faq.label;
    setSelectedFaq(faq);
  };

  const handleReorder = async (faqs: Faq[]) => {
    if (!organizationId || !data) return;

    const reorderedFaqs = faqs.map((faq) => ({
      ...faq,
    }));

    await updateFaq({
      organizationId,
      faq: reorderedFaqs,
    });
  };

  const onClose = () => {
    setSelectedFaq(undefined);
  };

  if (isLoading) {
    return (
      <Stack flex={1} justifyContent="center" alignItems="center">
        <CircularProgress />
      </Stack>
    );
  }

  if (!data) {
    return <EmptyState />;
  }

  // console.log("~ data:", data);

  return (
    <Stack spacing={3}>
      <PageHeader
        title="Preguntas Frecuentes"
        action={
          hasAccess("update.organization") ? (
            <Button size="large" color="success" type="submit" fullWidth={false} onClick={() => setSelectedFaq(EMPTY_FAQ)}>
              Crear
            </Button>
          ) : undefined
        }
      />
      <Paper sx={{ padding: 2 }}>
        <Stack gap={2}>
          {data.length == 0 ? (
            <EmptyState title="Sin Preguntas Frecuentes" description="Cuando agregues preguntas frecuentes se mostrarán aquí" />
          ) : (
            <SortableList<Faq>
              items={data.map((faq) => ({
                ...faq,
                // id: faq.id,
                label: faq.question,
              }))}
              onDelete={(_, deletefFaq: any) => handleDelete(deletefFaq.id)}
              onEdit={handleEdit}
              onChange={handleReorder}
              deleteConfirmation
            />
          )}
        </Stack>
      </Paper>

      <Drawer value={selectedFaq as Faq} onClose={onClose} />
    </Stack>
  );
};

export default OrganizationFaqs;
